import React from 'react'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const customStyle = label => {
  switch (label) {
    case 'Unit':
      return { fontSize: '1.5rem' }
    default:
      return {}
  }
}

const CalculatorSelect = ({ selectedValue, values, label, titleTag, callback, fnKey, currentCamera, labelClass, classes }) => {
  return (
    <div className={classes.container}>
      <div title={titleTag || label} className={classes[labelClass] || classes.normalLabel}>{label}</div>
      <div className={classes.inputWrapper}>
        <FontAwesomeIcon icon='caret-down' className={classes.caretDown} />
        <select
          value={selectedValue}
          onChange={({ target }) => { callback(target.value, fnKey, currentCamera.id) }}
          style={customStyle(label)}
        >
          {
            values.map((obj, i) => {
              return <option key={i} value={obj.value}>{obj.text}</option>
            })
          }
        </select>
      </div>
    </div>
  )
}

export default injectSheet(style)(CalculatorSelect)



// WEBPACK FOOTER //
// ./src/components/CalculatorSelect/index.js